import React from "react";
import ReviseDocument from "../Components/DocumentCrafting/Revise/ReviseDocument";

const DocumentCraftingRevisePage: React.FC = () => <ReviseDocument />;

export default DocumentCraftingRevisePage;
